<script setup lang="ts">
import { useEcomStore } from '@/stores/apps/eCommerce';
import { useInvoiceStore } from '@/stores/apps/invoice';
import { formatCurrency } from '@/utils/format';

const store = useEcomStore();
const invoice = useInvoiceStore();
const stores = useStoresStore()

const props = defineProps({
    onlyTotal: {
        type: Boolean,
        default: false
    }
});

onMounted(async () => {
    await store.updateTotals();
});

// const getSubtotal = computed(() => {
//     return store.subtotal;
// });
// const subtotal = ref(getSubtotal);
// const Discount = reactive(Math.round(subtotal.value * (5 / 100)));
// const total = reactive(getSubtotal.value - Discount);
</script>
<template>
    <v-card variant="outlined" elevation="0" class="px-1 pt-0 mt-2" v-bind="$attrs">
        <v-card-item v-if="!onlyTotal" class="px-1 pa-0">
            <div class="overflow-auto rounded-md pa-3 mt-2">
                <h5 class="text-h5 mb-4">{{ $t('Order Summary') }} <span v-if="invoice.invoiceId" class="text-subtitle-1"> # {{ (invoice.invoiceId??0).toString().padStart(7, '0') }}</span></h5>
                <div class="d-flex align-center justify-space-between my-2">
                    <h6 class="text-h6 font-weight-regular">{{ $t('Subtotal') }}</h6>
                    <h6 class="font-weight-semibold text-h6">{{ formatCurrency(store.subtotal) }}</h6>
                </div>

                <div v-if="store.discount !== 0" class="d-flex align-center justify-space-between my-2">
                    <h6 class="text-h6 font-weight-regular text-success">{{ $t('Discount') }}</h6>
                    <h6 class="font-weight-semibold text-h6 text-success">- {{ formatCurrency(store.discount) }}</h6>
                </div>

                <!-- <div class="d-flex align-center justify-space-between my-2">
                    <h6 class="text-h6 font-weight-regular">{{ $t('Taxes') }}</h6>
                    <h6 class="font-weight-semibold text-h6">{{ formatCurrency(store.taxes) }}</h6>
                </div> -->

                <div class="d-flex align-center justify-space-between mt-2">
                    <h6 class="text-h6">{{ $t('payment.totalToPay')  }}</h6>
                    <h6 class="font-weight-semibold text-h5">{{ formatCurrency(store.total) }}</h6>
                </div>
            </div>
        </v-card-item>
        <v-card-item v-else class="pa-3">
            <h5 class="text-h5" v-if="invoice.invoiceId">{{ $t('Order Number') }} # {{ (invoice.invoiceId??0).toString().padStart(7, '0') }}</h5>

            <div class="d-flex align-center justify-space-between">
                <h5 class="text-h5 font-weight-bold">subtotal</h5>
                <h5 class="font-weight-bold text-h5">{{ formatCurrency(store.subTotal) }}</h5>
            </div>
            <div class="d-flex align-center justify-space-between">
                <h5 class="text-h5 font-weight-bold">impuestos</h5>
                <h5 class="font-weight-bold text-h5">{{ formatCurrency(store.taxes) }}</h5>
            </div>

            <div class="d-flex align-center justify-space-between">
                <h5 class="text-h5 font-weight-bold">{{ $t('Total order') }}</h5>
                <h5 class="font-weight-bold text-h5">{{ formatCurrency(store.total) }}</h5>
            </div>
        </v-card-item>
    </v-card>
</template>